import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=male&exp=web_pricing_on_fasting_funnels_with_sp_nonus~1&sex=male
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_pricing_on_fasting_funnels_with_sp_nonus/male'
					),
			},
		},
	},
]

export default config
